module.exports = __webpack_public_path__ + "img/7.6b853c9a.png";